export default __webpack_public_path__ + "static/blob-12-b960a1122ea26ceb03006ac093779360.svg";